"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof _Symbol && "symbol" == typeof _Symbol$iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof _Symbol && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _Symbol$iterator = require("@babel/runtime-corejs3/core-js/symbol/iterator");

var _Array$from = require("@babel/runtime-corejs3/core-js/array/from");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Symbol = require("@babel/runtime-corejs3/core-js/symbol");

var _Array$isArray = require("@babel/runtime-corejs3/core-js/array/is-array");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/slice");

var _Symbol$replace = require("@babel/runtime-corejs3/core-js/symbol/replace");

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _reduceInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/reduce");

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _Object$create = require("@babel/runtime-corejs3/core-js/object/create");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isWeixinBrowser = exports.isWeiboBrowser = exports.isQQWebview = exports.isQQTBSBrowser = exports.isMobile = exports.isMissEvanApp = exports.isInSafari = exports.isInNormalBrowser = exports.isInBiliApp = exports.isIOS = exports.isGeneralMobile = exports.isBiliApp = exports.isBiliActivityMobile = exports.isAppOlderThan = exports.isAndroid = exports.getIOSVersion = exports.getAppVersion = exports.getAppInfo = exports.EOS = exports.EDevice = exports.EAppTheme = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/bind"));

var _setPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/set-prototype-of"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _jsBridge = require("@bilibili/js-bridge");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { var _context5; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context5 = Object.prototype.toString.call(o)).call(_context5, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof _Symbol !== "undefined" && _getIteratorMethod(arr) || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (_Array$isArray(arr)) return arr; }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new _WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var _context4; var g = _groups.get(re); return _reduceInstanceProperty(_context4 = _Object$keys(g)).call(_context4, function (groups, name) { return groups[name] = result[g[name]], groups; }, _Object$create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[_Symbol$replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[_Symbol$replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[_Symbol$replace].call(this, str, function () { var args = arguments; return "object" != _typeof(args[args.length - 1]) && (args = _sliceInstanceProperty([]).call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[_Symbol$replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = _Object$create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); _Object$defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { var _context3; _setPrototypeOf = _setPrototypeOf2.default ? (0, _bind.default)(_context3 = _setPrototypeOf2.default).call(_context3) : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// 匹配客户端 UA 中的版本号和额外信息
// 客户端 UA 例子：`MissEvanApp/5.5.8 (Theme Light; NetType 4G; FreeFlow)`
var MissEvanAppRegex = /*#__PURE__*/_wrapRegExp(/MissEvanApp\/(\S+) (\((.+?)\))?/, {
  version: 1,
  extraInfo: 3
});

var isMissEvanApp = function isMissEvanApp() {
  return !!navigator.userAgent.match(MissEvanAppRegex);
};

exports.isMissEvanApp = isMissEvanApp;

var isBiliApp = function isBiliApp() {
  return /BiliApp/i.test(navigator.userAgent);
};

exports.isBiliApp = isBiliApp;

var isMobile = function isMobile() {
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

exports.isMobile = isMobile;

var isIOS = function isIOS() {
  return /iPhone|iPod|iPad/i.test(navigator.userAgent);
};

exports.isIOS = isIOS;

var isAndroid = function isAndroid() {
  return /Android/i.test(navigator.userAgent);
};

exports.isAndroid = isAndroid;

var isWeixinBrowser = function isWeixinBrowser() {
  return /micromessenger/i.test(navigator.userAgent);
};

exports.isWeixinBrowser = isWeixinBrowser;

var isQQWebview = function isQQWebview() {
  return /\Wqq\W/i.test(navigator.userAgent);
}; // 判断是否为腾讯 X5 内核浏览器 或者 QQ 浏览器


exports.isQQWebview = isQQWebview;

var isQQTBSBrowser = function isQQTBSBrowser() {
  return /(?=.*qq)(?=.*tbs)/i.test(navigator.userAgent) || /MQQBrowser/i.test(navigator.userAgent);
};

exports.isQQTBSBrowser = isQQTBSBrowser;

var isWeiboBrowser = function isWeiboBrowser() {
  return /weibo/i.test(navigator.userAgent);
}; // 某些 Android 手机 QQ 内置浏览器的 UA 会包含 Safari


exports.isWeiboBrowser = isWeiboBrowser;

var isInSafari = function isInSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

exports.isInSafari = isInSafari;

var isInNormalBrowser = function isInNormalBrowser() {
  return !isWeixinBrowser() && !isWeiboBrowser() && !isQQTBSBrowser() && !isInSafari();
};

exports.isInNormalBrowser = isInNormalBrowser;

var isInBiliApp = function isInBiliApp() {
  return _jsBridge.inBiliApp || /BiliApp/i.test(navigator.userAgent);
};

exports.isInBiliApp = isInBiliApp;

var isBiliActivityMobile = function isBiliActivityMobile() {
  var _window;

  return ((_window = window) === null || _window === void 0 ? void 0 : _window.__BILIACT_ENV__) === 'H5';
};

exports.isBiliActivityMobile = isBiliActivityMobile;

var isGeneralMobile = function isGeneralMobile() {
  return isMobile() || isBiliActivityMobile();
};

exports.isGeneralMobile = isGeneralMobile;

var getIOSVersion = function getIOSVersion() {
  var match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);

  if (!match) {
    return null;
  }

  var _match = _slicedToArray(match, 4),
      major = _match[1],
      minor = _match[2],
      patch = _match[3];

  return {
    major: major ? (0, _parseInt2.default)(major) : 0,
    minor: minor ? (0, _parseInt2.default)(minor) : 0,
    patch: patch ? (0, _parseInt2.default)(patch) : 0
  };
};
/**
 * 获取版本号
 * @param   {string} versionStr 版本号字符串
 * @returns {number} 版本号
 * @example '1.2.3' => 10203
 */


exports.getIOSVersion = getIOSVersion;

var getAppVersion = function getAppVersion(versionStr) {
  var version = 0;

  if (!versionStr) {
    return version;
  }

  var vers = versionStr.split('.');

  if (vers && vers.length > 0) {
    // eslint-disable-next-line no-magic-numbers
    version = (0, _parseInt2.default)(vers[0]) * 10000;

    if (vers.length > 1) {
      version += (0, _parseInt2.default)(vers[1]) * 100;
    } // eslint-disable-next-line no-magic-numbers


    if (vers.length > 2) {
      version += (0, _parseInt2.default)(vers[2]);
    }
  }

  return version;
};

exports.getAppVersion = getAppVersion;
var EDevice;
exports.EDevice = EDevice;

(function (EDevice) {
  EDevice["Android"] = "android";
  EDevice["IOS"] = "ios";
})(EDevice || (exports.EDevice = EDevice = {}));

var EOS;
exports.EOS = EOS;

(function (EOS) {
  EOS[EOS["Android"] = 1] = "Android";
  EOS[EOS["IOS"] = 2] = "IOS";
})(EOS || (exports.EOS = EOS = {}));

var EAppTheme;
exports.EAppTheme = EAppTheme;

(function (EAppTheme) {
  EAppTheme["Light"] = "Light";
  EAppTheme["Dark"] = "Dark";
})(EAppTheme || (exports.EAppTheme = EAppTheme = {}));

var getAppInfo = function getAppInfo() {
  var _m$groups$version, _m$groups, _m$groups2;

  var m = navigator.userAgent.match(MissEvanAppRegex);

  if (!m) {
    return null;
  }

  var versionStr = (_m$groups$version = (_m$groups = m.groups) === null || _m$groups === void 0 ? void 0 : _m$groups.version) !== null && _m$groups$version !== void 0 ? _m$groups$version : '';
  var version = getAppVersion(versionStr);
  var device;
  var os;

  if (isIOS()) {
    device = EDevice.IOS;
    os = EOS.IOS;
  } else if (isAndroid()) {
    device = EDevice.Android;
    os = EOS.Android;
  } else {
    return null;
  }

  var theme;
  var netType;
  var freeFlow = false;
  var extraInfo = (_m$groups2 = m.groups) === null || _m$groups2 === void 0 ? void 0 : _m$groups2.extraInfo;

  if (extraInfo) {
    var _context, _context2;

    // 解析 `extraInfo` 中的 KVP，例如：`Theme Light; NetType 4G; FreeFlow;`
    (0, _forEach.default)(_context = (0, _map.default)(_context2 = extraInfo.split(';')).call(_context2, function (v) {
      return (0, _trim.default)(v).call(v);
    })).call(_context, function (v) {
      if ((0, _startsWith.default)(v).call(v, 'Theme ')) {
        theme = v.split(' ')[1];
        return;
      }

      if ((0, _startsWith.default)(v).call(v, 'NetType ')) {
        netType = v.split(' ')[1];
        return;
      }

      if (v === 'FreeFlow') {
        freeFlow = true;
      }
    });
  }

  return {
    device: device,
    os: os,
    version: version,
    versionStr: versionStr,
    theme: theme,
    netType: netType,
    freeFlow: freeFlow
  };
};

exports.getAppInfo = getAppInfo;

/**
 * 当前客户端版本是否小于指定版本
 * @description 不传指定版本则返回 false 表示支持某功能
 * @param   {IAppVersion} appVersion 指定版本
 * @returns {boolean} 小于特定版本则返回 true 其他都返回 false
 */
var isAppOlderThan = function isAppOlderThan(appVersion) {
  var appInfo = getAppInfo();

  if (!appInfo) {
    return false;
  }

  var device = appInfo.device,
      version = appInfo.version;
  var android = appVersion.android,
      ios = appVersion.ios;

  if (device === EDevice.Android && android) {
    return version < getAppVersion(android);
  }

  if (device === EDevice.IOS && ios) {
    return version < getAppVersion(ios);
  } // 不在客户端内


  return false;
};

exports.isAppOlderThan = isAppOlderThan;